<template>
    <div 
        class="message-container message-container--info" 
        :class="{hide: !infoMessage}" 
        @click="clearInfoMessage"
    >
        <span 
            class="message" 
            v-if="infoMessage"
        >{{ infoMessage }}</span>
        <i class="fa fa-times message-close" />
    </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
    data: function() {
        return {
            timeout: null,
        };
    },
    computed: {
        ...mapState(['infoMessage']),
    },

    watch: {
        infoMessage: function () {
            window.clearTimeout(this.timeout);
            this.timeout = window.setTimeout(() => {
                this.clearInfoMessage();
            }, 10000);
        }
    },
        
    methods: {
        ...mapMutations(['clearInfoMessage']),
    },

};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/InfoMessage.vue